<template>
  <b-container fluid class="bv-example-row orderHistory">
    <b-row>
      <b-col class="page-info">
        <div class="page-info-title">{{ $t('orderHistory.pastOrderHistory') }}</div>
        <div class="page-info-description">
          {{ $t('orderHistory.nMenusOfOrderAtYourLastArrivalAtOurStoreWillBeShown-prefix') }}
          {{ history.length }}
          {{ $t('orderHistory.nMenusOfOrderAtYourLastArrivalAtOurStoreWillBeShown-suffix') }}<br />
          {{ $t('orderHistory.pastOrderHistoryDescription') }}
        </div>
      </b-col>
    </b-row>
    <b-row
      v-for="order in history"
      :key="order.id"
      :order="order"
      class="history-list"
      align-v="center"
    >
      <b-col cols="6" style="padding-right: 5px">
        <div class="history-list-title">{{ order.itemName }}</div>
        <div class="history-list-topping">{{ toppingNames(order.toppings) }}</div>
      </b-col>
      <b-col cols="2" style="padding-right: 5px; padding-left: 5px">
        <div class="history-list-dish">
          <span>{{ order.quantity }}</span>
          <template v-if="!isJa">{{ unit[order.unit] }}</template>
        </div>
      </b-col>
      <b-col v-if="order.isOrderable" cols="4" style="padding-left: 5px">
        <div class="history-list-button" @click="goOrder(order)">
          <div class="history-list-button_order">
            {{ $t('common.order') }}
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
// config
import config from '@/config/config'
// module
import * as api from '@/api'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      history: [],
      historyMaxCount: 100, // TODO: default 見直し
    }
  },
  computed: {
    unit() {
      return config.unit[this.languageId]
    },
    ...mapGetters({
      languageId: 'setting/getLanguage',
      shopId: 'seat/getShopId',
    }),
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isJa() {
      return this.defaultLanguage === 'ja'
    },
  },
  watch: {
    languageId() {
      this.fetchHistory()
    },
    shopId(shopId) {
      if (shopId !== null) {
        this.fetchHistory()
      }
    },
  },
  mounted() {
    if (this.seatNo !== null) {
      this.fetchHistory()
    }
  },
  methods: {
    toppingNames(toppings) {
      var toppingNames = toppings.map((topping) => topping.name)
      return toppingNames.join(' ')
    },
    goOrder(order) {
      this.$router.push({
        name: 'historyOrder',
        params: { historyId: order.id, id: order.itemCode },
      })
    },
    fetchHistory() {
      api.fetchPastHistory(this.shopId).then((res) => {
        this.history = res.data.list
      })
    },
  },
}
</script>
